/** Texts of document templates and PDF documents (docs/architecture/documents.md). */
export const documentsDe = {
  placeholders: {
    companyName: 'Firma',
    createdAt: 'Erstellt am',
    author: 'Erstellt von',
    authorRole: 'Funktion der erstellenden Person',
    page: 'Seitenzahl',
    pages: 'Seitenanzahl',
  },
  placeholderGroups: { document: 'Dokument', page: 'Seite' },
  blocks: {
    text: {
      label: 'Text',
      description: 'Freier Text mit Überschriften, Tabellen, Bildern und Platzhaltern.',
    },
    pageBreak: {
      label: 'Seitenumbruch',
      description: 'Der folgende Inhalt beginnt auf einer neuen Seite.',
    },
    signature: {
      label: 'Unterschriften',
      description: 'Unterschriftszeilen nebeneinander, ab vier Personen in weiteren Reihen.',
    },
    findingsSummary: {
      label: 'Mängelübersicht',
      description: 'Tabelle mit Nummer, Titel, Kategorie, Priorität und Status.',
    },
    findingsDetails: {
      label: 'Mängel im Einzelnen',
      description:
        'Jeder Mangel mit Beschreibung, Maßnahme, Rechtsgrundlage, Fotos und Plan- oder Kartenausschnitt.',
    },
    findingsTable: {
      label: 'Mängeltabelle',
      description:
        'Mängel als Tabelle, nach Kategorie oder Gruppe gegliedert, auf Wunsch im Querformat.',
    },
    findingsPlans: {
      label: 'Mängelpläne und Karte',
      description:
        'Jede Planseite mit ihren Markern auf einer eigenen Seite, Mängel mit GPS-Punkt auf einer Karte.',
    },
    questionnaire: { label: 'Fragebogen', description: 'Fragen und Antworten des Datensatzes.' },
    source: { label: 'Daten des Datensatzes', description: 'Tabelle oder Text aus dem Datensatz.' },
    attachments: {
      label: 'Anhänge',
      description: 'PDF-Dateien des Datensatzes am Ende, ohne Kopf- und Fußzeile.',
    },
  },
  templates: {
    title: 'Dokumentvorlagen: {{document}}',
    sync: 'Dokumentvorlagen',
    description: 'Aufbau des Dokuments mit Deckblatt, Kopf- und Fußzeile und Inhalt.',
    empty: 'Noch keine Vorlage für dieses Dokument.',
    emptyDefaults: 'Übernimm die Standardinhalte des Moduls oder lege eine eigene Vorlage an.',
    default: 'Standard',
    inactive: 'Inaktiv',
    actions: 'Aktionen für „{{name}}“',
    makeDefault: 'Als Standard festlegen',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    copy: 'Kopieren',
    moveUp: '„{{name}}“ nach oben',
    moveDown: '„{{name}}“ nach unten',
    create: 'Neue Vorlage',
    createTitle: 'Neue Vorlage',
    copyTitle: 'Vorlage kopieren',
    copyName: '{{name}} (Kopie)',
    importTitle: 'Vorlage importieren',
    importDescription: 'Die Vorlage wird mit ihren Bildern unter diesem Namen angelegt.',
    name: 'Name',
    loadDefaults: 'Standardinhalte übernehmen',
    defaultsLoaded_one: '{{count}} Vorlage übernommen.',
    defaultsLoaded_other: '{{count}} Vorlagen übernommen.',
    defaultsNone: 'Alle Standardvorlagen sind schon vorhanden.',
    import: 'Vorlage importieren',
    created: 'Vorlage „{{name}}“ angelegt.',
    copied: 'Vorlage „{{name}}“ angelegt.',
    imported: 'Vorlage „{{name}}“ importiert.',
    deleted: 'Vorlage „{{name}}“ gelöscht.',
    saved: 'Vorlage „{{name}}“ gespeichert.',
    deleteTitle: 'Vorlage löschen?',
    deleteDescription:
      '„{{name}}“ wird mit ihren Bildern gelöscht. Bereits erstellte Dokumente bleiben erhalten.',
    errors: {
      'name-taken': 'Es gibt schon eine Vorlage mit diesem Namen.',
      'default-inactive': 'Eine inaktive Vorlage kann nicht Standard sein.',
      'block-not-allowed': 'Die Vorlage enthält Bausteine, die dieses Dokument nicht anbietet.',
      'source-unknown': 'Die Vorlage nennt Daten, die dieses Dokument nicht liefert.',
      'image-unknown': 'Ein Bild der Vorlage fehlt. Lade es erneut hoch.',
      'template-too-large': 'Die Vorlage ist zu groß.',
      'content-invalid': 'Der Inhalt der Vorlage ist ungültig.',
      importInvalid: 'Die Datei enthält keine Vorlage, die sich übernehmen lässt.',
      importFailed: 'Die Datei konnte gerade nicht gelesen werden. Versuche es erneut.',
      importImage: 'Ein Bild der Vorlage konnte nicht übernommen werden.',
      imageTooLarge: 'Das Bild ist zu groß. Erlaubt sind PNG und JPEG bis 5 MB.',
      imageFailed: 'Das Bild konnte nicht hochgeladen werden.',
    },
  },
  editor: {
    general: 'Allgemein',
    name: 'Name',
    orientation: 'Seitenformat',
    portrait: 'Hochformat',
    landscape: 'Querformat',
    cover: 'Deckblatt',
    coverDescription: 'Erste Seite des Dokuments, ohne Kopfzeile. Leer lassen für kein Deckblatt.',
    coverAlone: 'Deckblatt allein auf der ersten Seite',
    coverAloneDescription: 'Der Inhalt beginnt dann auf der zweiten Seite.',
    bands: 'Kopf- und Fußzeile',
    bandsDescription:
      'Auf jeder Seite außer den Anhängen, die Kopfzeile nicht auf dem Deckblatt. Für ein Logo neben Text eine Tabelle mit zwei Spalten einfügen; hier erscheint sie ohne Linien.',
    header: 'Kopfzeile',
    footer: 'Fußzeile',
    blocks: 'Inhalt',
    blocksDescription: 'Bausteine in der Reihenfolge, in der sie im Dokument erscheinen.',
    blocksEmpty: 'Noch kein Inhalt. Füge den ersten Baustein hinzu.',
    addBlock: 'Baustein hinzufügen',
    removeBlock: '„{{name}}“ entfernen',
    moveUp: '„{{name}}“ nach oben',
    moveDown: '„{{name}}“ nach unten',
    blockTitle: 'Überschrift',
    blockTitleDescription: 'Leer lassen für keine Überschrift.',
    photos: 'Fotos zeigen',
    planDetail: 'Plan- oder Kartenausschnitt zu jedem Mangel',
    groupBy: 'Gliederung',
    groupByNone: 'Keine',
    groupByCategory: 'Nach Kategorie',
    groupByGroup: 'Nach Gruppe',
    location: 'Spalte „Standort“ mit Plan- oder Kartenausschnitt',
    responsible: 'Spalte „Verantwortlich / Frist“',
    blockLandscape: 'Im Querformat',
    mapSections: 'Lange Strecken in Abschnitte teilen',
    mapSectionsHint:
      'Nach der Übersichtskarte folgt je etwa ein Kilometer eine eigene Karte. Aus: nur eine große Karte mit allen Mängeln.',
    who: 'Unterschrift von',
    whoAuthor: 'Person, die das Dokument erstellt',
    whoRecord: 'Personen des Datensatzes',
    note: 'Text über den Unterschriften',
    placeAndDate: 'Ort und Datum angeben',
    unsaved: 'Nicht gespeicherte Änderungen',
    discard: 'Verwerfen',
  },
  richText: {
    toolbar: 'Formatierung',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    blockType: 'Textart',
    paragraph: 'Absatz',
    heading1: 'Überschrift 1',
    heading2: 'Überschrift 2',
    heading3: 'Überschrift 3',
    bold: 'Fett',
    italic: 'Kursiv',
    underline: 'Unterstrichen',
    bulletList: 'Aufzählung',
    numberedList: 'Nummerierung',
    align: 'Ausrichtung',
    alignLeft: 'Linksbündig',
    alignCenter: 'Zentriert',
    alignRight: 'Rechtsbündig',
    alignJustify: 'Blocksatz',
    insertTable: 'Tabelle einfügen',
    table: 'Tabelle',
    rowAbove: 'Zeile oberhalb einfügen',
    rowBelow: 'Zeile unterhalb einfügen',
    columnLeft: 'Spalte links einfügen',
    columnRight: 'Spalte rechts einfügen',
    headerRow: 'Überschriftszeile',
    deleteRow: 'Zeile löschen',
    deleteColumn: 'Spalte löschen',
    deleteTable: 'Tabelle löschen',
    horizontalRule: 'Trennlinie',
    image: 'Bild',
    imageSize: 'Bildgröße',
    imageSizeOriginal: 'Logogröße',
    imageSizeSmall: 'Ein Viertel',
    imageSizeMedium: 'Halbe Breite',
    imageSizeLarge: 'Drei Viertel',
    imageSizeFull: 'Volle Breite',
    placeholder: 'Platzhalter',
    placeholderSearch: 'Platzhalter suchen',
    noResults: 'Keine Treffer',
  },
  preview: {
    title: 'Vorschau',
    description: 'Mit Beispieldaten erzeugt, so wie das Dokument aussehen wird.',
    refresh: 'Vorschau aktualisieren',
    outdated: 'Die Vorschau zeigt noch nicht die letzten Änderungen.',
    loading: 'Vorschau wird erzeugt …',
    failed: 'Die Vorschau konnte nicht erzeugt werden.',
    page: 'Seite {{page}} von {{pages}}',
    download: 'Als PDF herunterladen',
  },
  create: {
    title: '{{document}} erstellen',
    description: 'Das Dokument entsteht auf diesem Gerät, auch ohne Netz.',
    template: 'Vorlage',
    noTemplates: 'Für dieses Dokument gibt es noch keine aktive Vorlage.',
    noTemplatesManage: 'Vorlagen legst du in den Einstellungen des Moduls an.',
    checking: 'Daten werden geprüft …',
    complete: 'Für diese Vorlage ist alles vorhanden.',
    warnings: 'Bitte prüfen',
    errors: 'Das fehlt noch',
    attach: 'An den Datensatz anhängen',
    attachDescription: 'Das PDF wird bei den Dateien des Datensatzes abgelegt.',
    attachOffline: 'Anhängen geht nur mit Netz. Lade das Dokument herunter und hänge es später an.',
    attachQueued: 'Das PDF wartet auf diesem Gerät und wird beim nächsten Abgleich angehängt.',
    submit: 'Erstellen',
    created: 'Das Dokument wurde erstellt.',
    attached: 'Das Dokument wurde erstellt und an den Datensatz angehängt.',
    queued: 'Das Dokument wurde erstellt und wird angehängt, sobald wieder Netz da ist.',
    attachFailed: 'Das Dokument wurde erstellt, konnte aber nicht angehängt werden.',
    attachTooLarge:
      'Das Dokument wurde erstellt, ist zum Anhängen aber zu groß (höchstens {{size}}).',
    failed: 'Das Dokument konnte nicht erstellt werden.',
    loadFailed: 'Die Daten für das Dokument konnten nicht geladen werden.',
    pdfErrors: {
      'attachment-missing': 'Der Anhang „{{name}}“ ist nicht verfügbar.',
      'attachment-encrypted':
        'Der Anhang „{{name}}“ ist mit einem Kennwort geschützt. Lege eine Fassung ohne Kennwort ab.',
      'attachment-unreadable': 'Der Anhang „{{name}}“ ist beschädigt oder kein PDF.',
    },
  },
  sample: {
    author: 'Erika Beispiel',
    authorRole: 'Brandschutzbeauftragte',
    signer1Name: 'Max Mustermann',
    signer1Role: 'Objektleitung',
    signer2Name: 'Clara Probe',
    signer2Role: 'Haustechnik',
    place: 'Musterstadt',
    categoryEscape: 'Flucht- und Rettungswege',
    categoryDoors: 'Brandschutztüren',
    categoryExtinguishers: 'Feuerlöscher',
    groupStructural: 'Baulicher Brandschutz',
    groupTechnical: 'Anlagentechnischer Brandschutz',
    statusOpen: 'Offen',
    statusProgress: 'In Bearbeitung',
    statusDone: 'Erledigt',
    priorityHigh: 'Hoch',
    priorityMedium: 'Mittel',
    priorityLow: 'Niedrig',
    planName: 'Grundriss',
    planFloor: 'EG',
    finding1Title: 'Fluchtweg durch Lagerware eingeengt',
    finding1Description:
      'Im Gang zwischen den Regalen stehen Paletten. Die nutzbare Breite des Fluchtwegs beträgt an der engsten Stelle nur noch etwa 0,60 m.',
    finding1Measure: 'Paletten entfernen und den Fluchtweg dauerhaft auf ganzer Breite freihalten.',
    finding1LegalBasis: '§ 4 Abs. 4 ArbStättV; ASR A2.3, Abschnitt 5',
    finding1Area: 'Halle 1',
    finding1Caption: 'Gang zwischen den Regalen',
    finding2Title: 'Brandschutztür mit Keil offen gehalten',
    finding2Description:
      'Die Tür zum Treppenraum wird mit einem Holzkeil offen gehalten und kann im Brandfall nicht schließen.',
    finding2Measure: 'Keil entfernen; bei Bedarf eine zugelassene Feststellanlage einbauen lassen.',
    finding2LegalBasis: '§ 14 MBO',
    finding2Area: 'Treppenraum',
    finding2Caption: 'Tür zum Treppenraum',
    finding3Title: 'Feuerlöscher ohne gültige Prüfplakette',
    finding3Description: 'Die letzte Prüfung des Feuerlöschers liegt mehr als zwei Jahre zurück.',
    finding3Measure: 'Feuerlöscher durch eine sachkundige Person prüfen lassen.',
    finding3LegalBasis: 'ASR A2.2, Abschnitt 6; DGUV Information 205-001',
    finding3Room: 'Büro 0.04',
    finding4Title: 'Hinweisschild zum Sammelplatz verblasst',
    finding4Measure: 'Schild durch ein langnachleuchtendes Schild ersetzen.',
    finding5Title: 'Feuerwehrzufahrt frei und gut gekennzeichnet',
    finding5Description: 'Die Zufahrt ist auf ganzer Breite frei, die Schilder sind gut lesbar.',
    responsible1: 'Muster Logistik GmbH',
    responsible2: 'Haustechnik Beispiel KG',
    question1: 'Objekt vollständig begangen',
    question2: 'Letzte Prüfung der Brandmeldeanlage',
    question3: 'Anzahl der Beschäftigten',
    question4: 'Besonderheiten',
    answer4: 'Umbau im Obergeschoss, Bereich abgesperrt.',
    sourceText: 'Hier steht der Text, den der Datensatz liefert.',
    column: 'Spalte {{n}}',
    cell: 'Beispiel',
    attachmentTitle: 'Angehängtes Dokument (Beispiel)',
    attachmentName: 'Anhang.pdf',
  },
  pdf: {
    yes: 'Ja',
    no: 'Nein',
    question: 'Angabe',
    answer: 'Antwort',
    signatureName: 'Name',
    noFindings: 'Es wurden keine Mängel festgestellt.',
    noDefects: 'Es wurden keine Mängel festgestellt.',
    positives: 'Positive Feststellungen',
    positive: 'Positiv',
    positiveCount_one: 'Dazu {{count}} positive Feststellung.',
    positiveCount_other: 'Dazu {{count}} positive Feststellungen.',
    responsible: 'Verantwortlich / Frist',
    responsibleValue: 'Verantwortlich: {{name}}',
    dueBy: 'bis {{date}}',
    dueNote: 'Frist: {{text}}',
    number: 'Nr.',
    title: 'Titel',
    category: 'Kategorie',
    priority: 'Priorität',
    status: 'Status',
    positions_one: 'An {{count}} Standort festgestellt, siehe Mängelplan: {{plans}}.',
    positions_other:
      'An {{count}} Standorten festgestellt; die genaue Lage zeigen die Mängelpläne: {{plans}}.',
    planUnavailable: 'Der Plan konnte nicht geladen werden.',
    planDetail: 'Planausschnitt – {{plan}}',
    photoUnavailable: 'Foto nicht verfügbar',
    priorityValue: 'Priorität: {{value}}',
    statusValue: 'Status: {{value}}',
    foundOn: 'Festgestellt: {{date}}',
    dueOn: 'Fällig bis: {{date}}',
    resolvedOn: 'Behoben: {{date}}',
    place: 'Standort: {{place}}',
    measure: 'Empfohlene Maßnahme: {{text}}',
    legalBasisValue: 'Rechtsgrundlage: {{text}}',
    legalBases: 'Rechtsgrundlagen:',
    recommendation: 'Empfehlung: {{text}}',
    finding: 'Mangel oder Feststellung',
    legalBasis: 'Rechtsgrundlage / Vorschrift',
    location: 'Standort / Lokalisierung',
    photos: 'Fotos',
    noPosition: 'Kein Standort markiert',
    continuedRow: '{{title}} (Fortsetzung)',
    noCategory: 'Ohne Kategorie',
    noGroup: 'Ohne Gruppe',
    planPage: 'Seite {{page}}',
    planMarkers_one: '{{count}} Markierung',
    planMarkers_other: '{{count}} Markierungen',
    planFindings_one: '{{count}} Mangel eingetragen',
    planFindings_other: '{{count}} Mängel eingetragen',
    planShared_one: 'an {{count}} Punkt mehrere Mängel (Nummern am Marker aufgezählt)',
    planShared_other: 'an {{count}} Punkten mehrere Mängel (Nummern am Marker aufgezählt)',
    geo: 'GPS {{point}}',
    geoAccuracy: 'GPS {{point}} (±{{meters}} m)',
    map: 'Mängelkarte',
    mapOverview: 'Übersichtskarte',
    mapSection: 'Abschnitt {{index}} von {{count}}',
    mapSectionShort: 'Abschnitt {{index}}',
    mapSections_one: 'in {{count}} Abschnitt auf der folgenden Seite',
    mapSections_other: 'in {{count}} Abschnitten auf den folgenden Seiten',
    mapFindings_one: '{{count}} Mangel mit GPS-Punkt',
    mapFindings_other: '{{count}} Mängel mit GPS-Punkt',
    mapSectionFindings_one: 'Mangel {{labels}}',
    mapSectionFindings_other: 'Mängel {{labels}}',
    mapDetail: 'Kartenausschnitt',
    mapAttribution: 'Karte: © OpenStreetMap-Mitwirkende, OpenFreeMap',
    mapUnavailable:
      'Die Karte konnte nicht geladen werden, z. B. ohne Verbindung. Die Nummern stehen an ihrer Lage.',
  },
};
